import { LitElement, html, css } from "lit";
import { customElement, property, query } from "lit/decorators.js";
import "./url_row_widget";
import "@shoelace-style/shoelace/dist/components/button/button.js";
import '@shoelace-style/shoelace/dist/components/input/input.js';

@customElement("root-element")
export class RootElement extends LitElement {
    constructor() {
        super();
    }

    @property({ type: Object }) data = null;

    async firstUpdated() {
        try {
            const response = await fetch("./status");
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            this.data = await response.json();
        } catch (error) {
            console.error("Failed to fetch data:", error);
        }
    }

    render() {
        if (!this.data)
            return html`<div>Loading...</div>`;

        return html`
            <sl-alert open closable>
                <sl-icon slot="icon" name="info-circle"></sl-icon>
                ${this.data["status"]} ${this.data["version"]}
            </sl-alert>

            <url-widget></url-widget>

            <div id="addUrlSection">
                <sl-input id="inputUrl" type="url" placeholder="Enter url here" style="width: 100%;">
                    <sl-icon name="globe" slot="prefix"></sl-icon>
                </sl-input>
                <sl-button size="small" @click=${this.onAddClick} style="margin-top: 10px;">
                    <sl-icon name="plus" slot="prefix"></sl-icon>
                    Add
                </sl-button>
            </div>
        `;
    }

    onAddClick() {
        const inputElement = this.shadowRoot?.querySelector("#inputUrl") as HTMLInputElement;
        if (inputElement) {
            let url = inputElement.value.trim();
            if (url && !url.startsWith("http://") && !url.startsWith("https://")) {
                url = `http://${url}`;
            }
            console.log("Formatted URL:", url);
            // Add your logic here to handle the formatted URL
            fetch("./data/addmonitor", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ url }),
            })
                .then((response) => {
                    if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }
                    return response.json();
                })
                .then((data) => {
                    console.log("Successfully added URL:", data);
                    inputElement.value = ""; // Clear the input field
                })
                .catch((error) => {
                    console.error("Failed to add URL:", error);
                });
        }
    }

    static styles = css`
        sl-input#inputUrl {
            min-width: 150px;
            max-width: 50%;
        }

        #addUrlSection {
            margin: 20px 10px;
        }

        sl-alert[open] {
            margin: 10px;
        }
    `;
}
